import React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
const TabOverLayPopup = ({ message, iconClassName, button, }) => {
    return (React.createElement(OverlayTrigger, { trigger: "hover", placement: "bottom", overlay: React.createElement(Popover, { id: "popover-positioned-bottom", title: "Popover bottom", className: "tab-overlay-parent" },
            React.createElement("div", null, message)) }, button ? (button) : (React.createElement("i", { role: "button", className: `edel-icon-Information lh-base px-1 txt_blueLight3 ${iconClassName}` }))));
};
export default TabOverLayPopup;
